import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {UserService} from "../../../services/user.service";
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {EventBean} from "../../../beansts/Event";
import {CompanyBean} from "../../../beansts/company.bean";
import { TranslationService } from '../../../services/translation.service';

import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import {WalletService} from "../../../services/wallet.services";

declare let $: any;
declare var Swal : any;

@Component({
    selector : 'card-modal',
    templateUrl:'card-component.html',

})
export class CardModalComponent implements OnInit, OnDestroy{

  public processing : boolean=false;
  public tab=1;
  public date: Date = new Date();
  public gender='M'
  public kind=0;
  public settings = {
        bigBanner: true,
        timePicker: false,
        format: 'dd-MM-yyyy',
        defaultOpen: false
  }
  public brandValue;
  public numberMask = [/[0-9]/, /[0-9]/, /[0-9]/,/[0-9]/, '.',/[0-9]/,/[0-9]/,/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '.',/[0-9]/,/[0-9]/,/[0-9]/, /[0-9]/]
  public expirationMask = [ /[0-1]/,/[0-9]/,'/',/[0-2]/,/[0-9]/,/[0-9]/,/[0-9]/]
  public cvvMask = [/[0-9]/, /[0-9]/, /[0-9]/]
  public  imageStr;

  public profileForm : FormGroup;
  public basicMobileInfoForm : FormGroup;
  public canMailChange=true;
  public brands=[
    "VISA","MASTER","AMEX","ELO","AURA","DINERS","JCB","DISCOVER","HIPERCARD","HIPER"
  ]

  private user : InstagramUserBean;
  public constructor( private _router : Router,public _walletService: WalletService, public translate: TranslationService,private _auth : UserService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
      this.profileForm = this.fb.group({
        cardHolderName : '',
        cardNumber : '',
        cardExpiration : '',
        cardCvv: '',
        livecoinQuantity:10
      });

    }

    public changeAction(c) {
      this.brandValue=c
    }
    public ngOnInit(): any {

    }

    public onChange (params){
      this.ngOnInit();
  };
public buyLivecoins(){
  $('#profileModal').modal('hide')
  $('#cardModal').modal('show')


}
    public ngOnDestroy() : any {
    }

    public makePurchase() : void {
      this.processing = true;
      let form=this.profileForm;
     // if (window.innerWidth<window.innerHeight){
       // form=this.basicMobileInfoForm;
      //}
  
      let number : string      = form.controls['cardNumber'].value;
      let holder : string      = form.controls['cardHolderName'].value;
      let cvv : string = form.controls['cardCvv'].value;
      let expiration:string  =form.controls['cardExpiration'].value;
      let quantity:number = form.controls['livecoinQuantity'].value;


      if (!holder || holder.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('CARD_COMPONENT_6'),
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        })
        return;

      }
      if (!number || number.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('CARD_COMPONENT_7'),
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        })
        return;

      }
      if (!cvv || cvv.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('CARD_COMPONENT_8'),
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        })
        return;
      }
      if (!expiration || expiration.length==0){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('CARD_COMPONENT_9'),
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        })
        return;
      }
      if (quantity<10){
        Swal.fire({
          title: this.translate.instant('FAIL'),
          text: this.translate.instant('CARD_COMPONENT_10'),
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        })
        return;
      }
      if (!this.brandValue) this.brandValue='Visa'

      number=number.substring(0,4)+number.substring(5,9)+number.substring(10,14)+number.substring(15,19)
      Swal.fire({
                title: this.translate.instant('WAIT'),
                text: this.translate.instant('CARD_COMPONENT_11'),
                imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
                showConfirmButton: false
      })
      this._walletService.buyLivecoins( number, holder, cvv , expiration,this.brandValue, quantity).subscribe(res=>{
        if (res.status==200){         
          let transaction=res.json();
          this._walletService.transactionToLivecoin(transaction.result,'company').subscribe(v=>{
            if (res.status==200){         
                Swal.fire({title:this.translate.instant('SUCCESS'),text:this.translate.instant('CARD_COMPONENT_12')}) 
            }
            else{
                Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CARD_COMPONENT_13') })
            }
          },err=>{
            Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CARD_COMPONENT_13') })
          })
        }
        else{
          //put item back so others can get it
          Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CARD_COMPONENT_14') })
        }
        $('#cardModal').modal('hide')
      }
      ,err =>{
        $('#cardModal').modal('hide')
        Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CARD_COMPONENT_14')})
      })



  }





  
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+easylogin/card-modal/card-component.ts